document.addEventListener('DOMContentLoaded', function() {
    // Wait for the Yotpo widget to fully load
    let attempts = 0;
    const maxAttempts = 30; // Maximum 30 seconds wait time
  
    const checkYotpoLoaded = setInterval(function() {
      attempts++;
      const yotpoGallery = document.querySelector('.yotpo-pictures-widget');
  
      if (yotpoGallery) {
        clearInterval(checkYotpoLoaded);
        // Wait a bit longer for content to render
        setTimeout(initCarousel, 500);
      }
  
      if (attempts >= maxAttempts) {
        clearInterval(checkYotpoLoaded);
        initCarousel();
      }
    }, 1000);
  
    function initCarousel() {
      const progressBar = document.getElementById('instagramProgressBar');
      const carouselContainer = document.querySelector('.yotpo-pictures-widget');
  
      if (!progressBar || !carouselContainer) {
        return;
      }
  
      // Set the progress bar color from the data attribute
      const progressBarColor = progressBar.getAttribute('data-color');
      if (progressBarColor) {
        progressBar.style.backgroundColor = progressBarColor;
      }
  
      // Main selector for slides
      const allSlides = Array.from(document.querySelectorAll('.yotpo-single-image-container'));
  
      // Limit to a maximum of 71 slides
      const maxSlides = 71;
      const slides = allSlides.slice(0, maxSlides);
  
      // Hide slides that exceed the limit
      allSlides.forEach((slide, index) => {
        if (index >= maxSlides) {
          slide.style.display = 'none';
        }
      });
  
      const totalSlides = slides.length;
  
      if (totalSlides === 0) {
        progressBar.style.width = '100%';
        progressBar.style.display = 'block';
        return;
      }
  
      let currentSlideIndex = 0;
      updateProgressBar(currentSlideIndex);
  
      // --- NAVIGATION HANDLING (CLICKS) ---
      document.addEventListener('click', function(event) {
        let target = event.target;
        while (target && target !== document) {
          const isNextButton = target.closest('.yotpo-nav-next-button, [aria-label="Next"]');
          const isPrevButton = target.closest('.yotpo-nav-prev-button, [aria-label="Previous"]');
  
          if (isNextButton) {
            if (currentSlideIndex < totalSlides - 1) {
              currentSlideIndex++;
              updateProgressBar(currentSlideIndex);
            }
            return;
          }
  
          if (isPrevButton) {
            if (currentSlideIndex > 0 && progressBar.style.width !== '0%') {
              currentSlideIndex--;
              updateProgressBar(currentSlideIndex);
            }
            return;
          }
          target = target.parentElement;
        }
      });
  
      // --- TOUCH GESTURE HANDLING (MOBILE) ---
      let touchStartX = 0;
      carouselContainer.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
  
      carouselContainer.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].screenX;
        handleSwipe(touchStartX, touchEndX);
      }, { passive: true });
  
      // --- DRAG HANDLING (DESKTOP) ---
      let isDragging = false;
      let dragStartX = 0;
  
      carouselContainer.addEventListener('mousedown', (e) => {
        isDragging = true;
        dragStartX = e.screenX;
        carouselContainer.style.cursor = 'grabbing';
        e.preventDefault();
      });
  
      carouselContainer.addEventListener('mouseup', (e) => {
        if (isDragging) {
          isDragging = false;
          const dragEndX = e.screenX;
          carouselContainer.style.cursor = 'grab';
          handleSwipe(dragStartX, dragEndX);
        }
      });
  
      carouselContainer.addEventListener('mouseleave', () => {
        if (isDragging) {
          isDragging = false;
          carouselContainer.style.cursor = 'grab';
        }
      });
  
      // --- KEYBOARD NAVIGATION ---
      document.addEventListener('keydown', function(event) {
        if (event.key === 'ArrowRight') {
          const nextButton = carouselContainer.querySelector('.yotpo-nav-next-button, [aria-label="Next"]');
          if (nextButton && nextButton.style.pointerEvents !== 'none') {
            nextButton.click();
          }
        } else if (event.key === 'ArrowLeft') {
          const prevButton = carouselContainer.querySelector('.yotpo-nav-prev-button, [aria-label="Previous"]');
          if (prevButton && prevButton.style.pointerEvents !== 'none') {
            prevButton.click();
          }
        }
      });
  
      // --- NAVEGACIÓN CON RUEDA DEL MOUSE Y TRACKPAD (NUEVO) ---
      let canScroll = true; // Flag para controlar el cooldown del scroll
      carouselContainer.addEventListener('wheel', function(event) {
        // Si no podemos hacer scroll, salimos para evitar movimientos rápidos
        if (!canScroll) {
          event.preventDefault();
          return;
        }
        
        // Prevenimos el scroll vertical de la página
        event.preventDefault();
  
        // Priorizamos el scroll horizontal (trackpad) sobre el vertical (rueda de mouse)
        const scrollAmount = event.deltaX !== 0 ? event.deltaX : event.deltaY;
        
        if (scrollAmount > 1) { // Scroll hacia la derecha/abajo -> Siguiente
          const nextButton = carouselContainer.querySelector('.yotpo-nav-next-button, [aria-label="Next"]');
          if (nextButton && nextButton.style.pointerEvents !== 'none') {
            nextButton.click();
          }
        } else if (scrollAmount < -1) { // Scroll hacia la izquierda/arriba -> Anterior
          const prevButton = carouselContainer.querySelector('.yotpo-nav-prev-button, [aria-label="Previous"]');
          if (prevButton && prevButton.style.pointerEvents !== 'none') {
            prevButton.click();
          }
        }
        
        // Activamos el cooldown
        canScroll = false;
        setTimeout(() => {
          canScroll = true;
        }, 300); // 300 milisegundos de espera antes del siguiente scroll
  
      }, { passive: false }); // passive: false es necesario para que preventDefault() funcione
  
  
      // --- CENTRALIZED SWIPE AND DRAG LOGIC ---
      function handleSwipe(startX, endX) {
        const swipeThreshold = 50;
        const swipeDistance = endX - startX;
  
        if (Math.abs(swipeDistance) < swipeThreshold) return;
  
        if (swipeDistance < 0) { // Swipe left (Next)
          const nextButton = carouselContainer.querySelector('.yotpo-nav-next-button, [aria-label="Next"]');
          if (nextButton) {
            nextButton.click();
          }
        } else { // Swipe right (Previous)
          const prevButton = carouselContainer.querySelector('.yotpo-nav-prev-button, [aria-label="Previous"]');
          if (prevButton) {
            prevButton.click();
          }
        }
      }
  
      // --- FUNCTION TO UPDATE PROGRESS BAR ---
      function updateProgressBar(current) {
        const percentage = totalSlides > 1 ? (current / (totalSlides - 1)) * 100 : 100;
        progressBar.style.width = percentage + '%';
        progressBar.style.display = 'block';
  
        // Disable/Enable navigation buttons
        const prevButton = carouselContainer.querySelector('.yotpo-nav-prev-button, [aria-label="Previous"]');
        const nextButton = carouselContainer.querySelector('.yotpo-nav-next-button, [aria-label="Next"]');
  
        if (prevButton) {
          prevButton.style.opacity = current === 0 ? '0.3' : '1';
          prevButton.style.pointerEvents = current === 0 ? 'none' : 'auto';
        }
  
        if (nextButton) {
          nextButton.style.opacity = current === totalSlides - 1 ? '0.3' : '1';
          nextButton.style.pointerEvents = current === totalSlides - 1 ? 'none' : 'auto';
        }
      }
  
      // Set initial cursor state and buttons
      carouselContainer.style.cursor = 'grab';
      updateProgressBar(currentSlideIndex);
    }
  });